import React from 'react';
import Icon from './Icon';

const CopyIcon = (props) => (
    <Icon {...props}>
        <path
            d="M11 8H18A2 2 0 0 1 20 10V19A2 2 0 0 1 18 21H11A2 2 0 0 1 9 19V10A2 2 0 0 1 11 8ZM6 16A2 2 0 0 1 4 14V5A2 2 0 0 1 6 3H13A2 2 0 0 1 15 5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default CopyIcon;